import { Injectable } from "@angular/core";
import { GeoCodeService } from "./geocode/geo-code.service";
import { LocalStorageService } from "../shared/local-storage/local-storage.service";
import { LocationService } from "../location-service/location.service";
import { CscdataService } from "src/app/services/common/cscdata/cscdata.service";

@Injectable({
  providedIn: "root",
})
export class DateFormatService {
  constructor(
    public geoCodeService: GeoCodeService,
    public locationService: LocationService,
    public cscData: CscdataService
  ) {}

  async formatDates() {
    if (this.checkIsCustomer()) {
      let localTime = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await this.cscData
        .getCSCdata(false, false, false, localTime)
        .toPromise()
        .then((res) => {
          console.log(res);
          this.locationService.country = res.name;
          console.log(this.locationService.country);
        });
    } else {
      let currentBusinessUnit = JSON.parse(
        sessionStorage.getItem("currentBusinessUnit")
      );
      this.locationService.country = currentBusinessUnit.address?.country;
    }
    if (
      this.locationService.country == "United States" ||
      this.locationService.country == "India" ||
      this.locationService.country == "UK" ||
      this.locationService.country == "Ireland"
    ) {
      this.locationService.format = this.locationService.dateFormats[
        this.locationService.country
      ];
    } else {
      this.locationService.format = this.locationService.dateFormats.India;
    }
  }

  checkIsCustomer() {
    return JSON.parse(localStorage.getItem("user")).type === "B2C";
  }

  formatDate(date) {
    if (!date) {
      return;
    }
    var monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var day = date.getDate(),
      monthIndex = date.getMonth(),
      year = date.getFullYear().toString();
    return (
      day + this.nthNumber(day) + " " + monthNames[monthIndex] + " " + year
    );
  }
  nthNumber(number) {
    if (number > 3 && number < 21) return "th";
    switch (number % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
}
